function initCompanyCountryInput() {
  const countryInput = $('#company_address_attributes_country');

  updateCompanyInputsBasedOnCountry(countryInput.val());

  countryInput.on('change', function() {
    updateCompanyInputsBasedOnCountry($(this).val());
  });
}

function updateCompanyInputsBasedOnCountry(country) {
  const registrationNumberTypeSpan = $('.registration_number_type');
  const otherFiscalCategoryOption = $('#company_fiscal_category option[value="other"]');

  const countryArray = ['MX', 'CA', 'US']
  const areaLabel = $('label[for="company_address_attributes_area"]');
  const areaInput = $('#company_address_attributes_area')

  if (country === 'FR') {
    registrationNumberTypeSpan.text(' (SIRET)');
    otherFiscalCategoryOption.hide();
  } else if (countryArray.includes(country)) {
    const newAraText = areaLabel.text().replace(/( \*)?$/, ' *');
    areaLabel.text(newAraText);
    areaInput.prop('required', true)
  } else {
    registrationNumberTypeSpan.text('');
    otherFiscalCategoryOption.show();

    const newAraText = areaLabel.text().replace('*', '');
    areaLabel.text(newAraText);
    areaInput.prop('required', false)
  }
}

$(document).ready(initCompanyCountryInput);
